"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelOrderLine = void 0;
const helpers_1 = require("../../helpers");
const addOrderLog_1 = require("./addOrderLog");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const getOrderLineById_1 = require("./getOrderLineById");
const getOrderLineTitle_1 = require("./getOrderLineTitle");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const cancelOrderLine = async (supabase, order_line_id, status) => {
    const order_line = await (0, getOrderLineById_1.getOrderLineById)(supabase, order_line_id);
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_line.order_id);
    if (!order)
        throw new Error("Order not found");
    if (!order_line?.versions)
        throw new Error("Order line version not found");
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
    if (!latest_version)
        throw new Error("Order line does not have a version");
    latest_version.status = status || helpers_1.OrderLineStatus.CANCELLED;
    // update the order line
    await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, latest_version);
    await (0, addOrderLog_1.addOrderLog)(supabase, {
        type: order_line.type,
        created_by: order.client?.id,
        order_id: order_line.order_id,
        detail: {
            type: "Status Update",
            status: "CANCELLED",
            title: (0, getOrderLineTitle_1.getOrderLineTitle)(order_line),
            message: `Order Line Cancelled by client.`,
        },
    });
};
exports.cancelOrderLine = cancelOrderLine;
